import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchListItemMetadata'

export default defineMessages({
  preferredVendorLabel: {
    id: `${scope}.preferredVendorLabel`,
    defaultMessage: 'Preferred vendor',
  },
  invoiceNumberLabel: {
    id: `${scope}.invoiceNumberLabel`,
    defaultMessage: 'Invoice {invoiceNumber}',
  },
  externalPaymentMethodLabel: {
    id: `${scope}.externalPaymentMethodLabel`,
    defaultMessage: 'External',
  },
  amountLabel: {
    id: `${scope}.amountLabel`,
    defaultMessage: '{amount} {currency}',
  },
  twoPartLabel: {
    id: `${scope}.twoPartLabel`,
    defaultMessage: '{first} • {second}',
  },
  threePartLabel: {
    id: `${scope}.threePartLabel`,
    defaultMessage: '{first} • {second} • {third}',
  },
  ownerNameLabel: {
    id: `${scope}.ownerNameLabel`,
    defaultMessage: 'Owned by {name}',
  },
})
